import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface loadingState {
  loading: boolean;
  setLoading: (data: boolean) => void;
}

export const useLoaderStore = create<loadingState>()(
  devtools(
    (set) => ({
      loading: false,
      setLoading: (data) => {
        return set(
          () => ({
            loading: data,
          }));
      },
    }),
    {
      name: "LoaderStore",
    }
  )
);
